import React, { FC, useContext } from "react";
import { Grid } from "@mui/material";
import { ContactUsSVG, GoalsSVG, QualityConsultingSVG, QuickDeliverySVG } from "components/assets";
import { LocaleContext } from "context/LocaleContext";
import { useDynamicPageContent } from "hooks/useDynamicPageContent";
import { DynamicViewContent, WButton } from "components";
import { UserContext } from "context/UserContext";
import { useHistory } from "react-router-dom";
import { ExplanationCard } from "components/ExplanationSVGCard";

export const ConsultingRecruitmentView: FC = () => {
  const { localize } = useContext(LocaleContext);

  const { isAuthenticated } = useContext(UserContext);

  const history = useHistory();

  const explanationCards: ExplanationCard[] = [
    {
      svg: <QualityConsultingSVG />,
      title: localize("consultingRecruitment.goodConsultsTitle"),
      subTitle: localize("consultingRecruitment.goodConsultsSubTitle"),
    },
    {
      svg: <QuickDeliverySVG />,
      title: localize("consultingRecruitment.quickDeliveryTitle"),
      subTitle: localize("consultingRecruitment.quickDeliverySubTitle"),
    },
    {
      svg: <GoalsSVG />,
      title: localize("consultingRecruitment.goalsTitle"),
      subTitle: localize("consultingRecruitment.goalsSubTitle"),
    },
    {
      svg: <ContactUsSVG />,
      title: localize("consultingRecruitment.contactUsTitle"),
      subTitle: localize("consultingRecruitment.contactUsSubTitle"),
    },
  ];

  const { pageContent, pageHTMLContent } = useDynamicPageContent({
    pageType: "looking_for_consultant",
  });

  return (
    <Grid container position="relative">
      <DynamicViewContent
        pageContent={pageContent}
        forceSuperHeader
        explanationCards={explanationCards}
        pageHTMLContent={pageHTMLContent}
      />
      {!isAuthenticated && (
        <Grid container justifyContent="center">
          <WButton variant="contained" onClick={() => history.push("/contactUs")}>
            {localize("dynamicViewsCTA.contactUs")}
          </WButton>
        </Grid>
      )}
    </Grid>
  );
};
